/* Ninho — theme scripts */
(function () {
  'use strict';

  const S = window.themeSettings || {};

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    const value = (cents / 100).toLocaleString('en-GB', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const fmt = S.moneyFormat || '£{{amount}}';
    return fmt.replace(/\{\{\s*\w+\s*\}\}/, value);
  }

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg) {
    const el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = msg;
    el.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { el.hidden = true; }, 2600);
  }

  /* ---------- Drawers ---------- */
  let lastFocus = null;
  function openDrawer(id) {
    const d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const f = d.querySelector('[data-drawer-close]');
    if (f) setTimeout(() => f.focus(), 50);
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach((d) => {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    if (e.target.closest('[data-drawer-close]')) {
      e.preventDefault();
      closeDrawers();
    }
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Basket (AJAX) ---------- */
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  async function refreshCart(open) {
    try {
      const res = await fetch(root + '?sections=cart-drawer');
      const data = await res.json();
      const html = new DOMParser().parseFromString(data['cart-drawer'], 'text/html');
      const fresh = html.querySelector('#CartDrawerInner');
      const current = document.getElementById('CartDrawerInner');
      if (fresh && current) current.innerHTML = fresh.innerHTML;
      const countEl = html.querySelector('[data-cart-count-value]');
      const count = countEl ? parseInt(countEl.getAttribute('data-cart-count-value'), 10) : 0;
      document.querySelectorAll('[data-cart-count]').forEach((el) => {
        el.textContent = count;
        el.hidden = count === 0;
      });
      if (open) openDrawer('CartDrawer');
    } catch (err) {
      window.location.href = S.cartUrl || '/cart';
    }
  }

  async function addToCart(form) {
    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    try {
      const res = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) {
        toast(data.description || 'Sorry, we couldn\'t add that to your basket.');
        return;
      }
      await refreshCart(true);
    } catch (err) {
      form.submit();
    } finally {
      if (btn) { btn.disabled = false; btn.innerHTML = label; }
    }
  }

  document.addEventListener('submit', (e) => {
    const form = e.target.closest('form[data-ajax-cart], form.js-ajax-cart');
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  async function changeLine(line, quantity) {
    const drawer = document.getElementById('CartDrawerInner');
    if (drawer) drawer.style.opacity = '.55';
    try {
      await fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      });
      await refreshCart(false);
    } finally {
      if (drawer) drawer.style.opacity = '';
    }
  }

  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-line-change]');
    if (!btn) return;
    e.preventDefault();
    changeLine(parseInt(btn.dataset.line, 10), parseInt(btn.dataset.qty, 10));
  });

  /* ---------- Quantity (+/-) ---------- */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.closest('.qty').querySelector('input');
    const next = Math.max(parseInt(input.min || '1', 10), (parseInt(input.value, 10) || 1) + parseInt(step.dataset.qtyStep, 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Product page ---------- */
  function initProduct(section) {
    const jsonEl = section.querySelector('[data-product-json]');
    if (!jsonEl) return;
    const product = JSON.parse(jsonEl.textContent);
    const form = section.querySelector('form.js-product-form');
    const idInput = form && form.querySelector('input[name="id"]');
    const submit = form && form.querySelector('[type="submit"]');
    const stickyBtn = document.querySelector('[data-sticky-atc-btn]');

    // Gallery
    const slides = section.querySelectorAll('.gallery__slide');
    const thumbs = section.querySelectorAll('.gallery__thumb');
    function showMedia(mediaId) {
      slides.forEach((s) => s.classList.toggle('is-active', s.dataset.mediaId === String(mediaId)));
      thumbs.forEach((t) => {
        const on = t.dataset.mediaId === String(mediaId);
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-current', on ? 'true' : 'false');
      });
    }
    thumbs.forEach((t) => t.addEventListener('click', () => showMedia(t.dataset.mediaId)));

    // Simple mobile swipe
    const main = section.querySelector('.gallery__main');
    if (main && slides.length > 1) {
      let x0 = null;
      main.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) {
          const list = Array.from(slides);
          const i = list.findIndex((s) => s.classList.contains('is-active'));
          const n = (i + (dx < 0 ? 1 : -1) + list.length) % list.length;
          showMedia(list[n].dataset.mediaId);
        }
        x0 = null;
      });
    }

    // Variants
    function currentOptions() {
      return Array.from(section.querySelectorAll('[data-option-index]')).map((fs) => {
        const checked = fs.querySelector('input:checked');
        return checked ? checked.value : null;
      });
    }
    function updatePrice(variant) {
      const wrap = section.querySelector('[data-price-wrapper]');
      if (!wrap) return;
      const priceEl = wrap.querySelector('[data-price]');
      const cmp = wrap.querySelector('[data-compare-price]');
      const badge = wrap.querySelector('[data-sale-badge]');
      const inst = wrap.querySelector('[data-installments]');
      const pix = wrap.querySelector('[data-pix]');
      priceEl.textContent = formatMoney(variant.price);
      const onSale = variant.compare_at_price && variant.compare_at_price > variant.price;
      if (cmp) { cmp.hidden = !onSale; cmp.textContent = onSale ? formatMoney(variant.compare_at_price) : ''; }
      if (badge) {
        badge.hidden = !onSale;
        if (onSale) badge.textContent = '-' + Math.floor(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price) + '%';
      }
      if (inst && S.installments > 1) {
        inst.innerHTML = 'or ' + S.installments + ' interest-free payments of <strong>' + formatMoney(Math.floor(variant.price / S.installments)) + '</strong>';
      }
      if (pix && S.pixDiscount > 0) {
        pix.innerHTML = '<strong>' + formatMoney(Math.floor(variant.price * (100 - S.pixDiscount) / 100)) + '</strong> when you pay by bank transfer (' + S.pixDiscount + '% off)';
      }
      const stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);
    }
    function setButton(text, disabled) {
      [submit, stickyBtn].forEach((b) => {
        if (!b) return;
        b.disabled = disabled;
        const span = b.querySelector('[data-btn-label]');
        if (span) span.textContent = text; else b.textContent = text;
      });
    }
    section.addEventListener('change', (e) => {
      if (!e.target.closest('[data-option-index]')) return;
      const opts = currentOptions();
      const variant = product.variants.find((v) => v.options.every((o, i) => o === opts[i]));
      section.querySelectorAll('[data-option-label-value]').forEach((el, i) => { el.textContent = opts[i] || ''; });
      if (!variant) { setButton('Unavailable', true); return; }
      idInput.value = variant.id;
      updatePrice(variant);
      setButton(variant.available ? 'Buy now' : 'Sold out', !variant.available);
      if (variant.featured_media) showMedia(variant.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url.toString());
    });

    // Sticky buy bar (mobile)
    const sticky = document.querySelector('[data-sticky-atc]');
    if (sticky && submit && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(submit);
      if (stickyBtn) stickyBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (form.requestSubmit) form.requestSubmit(submit); else submit.click();
      });
    }
  }

  /* ---------- Countdown ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach((el) => {
      const end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      const parts = {
        d: el.querySelector('[data-d]'), h: el.querySelector('[data-h]'),
        m: el.querySelector('[data-m]'), s: el.querySelector('[data-s]')
      };
      function tick() {
        let diff = Math.max(0, end - Date.now());
        const d = Math.floor(diff / 864e5); diff -= d * 864e5;
        const h = Math.floor(diff / 36e5); diff -= h * 36e5;
        const m = Math.floor(diff / 6e4); diff -= m * 6e4;
        const s = Math.floor(diff / 1e3);
        parts.d.textContent = d; parts.h.textContent = String(h).padStart(2, '0');
        parts.m.textContent = String(m).padStart(2, '0'); parts.s.textContent = String(s).padStart(2, '0');
        if (end - Date.now() <= 0) el.hidden = true;
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function init() {
    document.querySelectorAll('[data-product-section]').forEach(initProduct);
    initCountdowns();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // Theme editor: re-init reloaded sections
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target.querySelector('[data-product-section]');
    if (s) initProduct(s);
    initCountdowns();
  });
})();
